import {withTranslation} from '@wix/yoshi-flow-editor'
import {OrderSummary as OrderSummaryPresentation} from './order-summary'

export const OrderSummary = withTranslation()(OrderSummaryPresentation)
